import React from 'react';
import { SideSummary } from '@components/common';
import GuideToRewarding from './assets/guide-to-rewarding.jpg';
import MembershipsStrategies from './assets/memberships-strategies.jpg';
import * as S from './styled';
export const HelpfulResources = () => {
    return (React.createElement(SideSummary, null,
        React.createElement(SideSummary.Item, { title: "Helpful resources" },
            React.createElement(S.Container, { href: "https://fourthwall.com/blog/5-memberships-strategies-from-fourthwall-creators", target: "_blank" },
                React.createElement(S.Name, null, "5 Memberships Strategies from Fourthwall Creators \u2197"),
                React.createElement(S.Image, { src: MembershipsStrategies }))),
        React.createElement(SideSummary.Item, null,
            React.createElement(S.Container, { href: "https://help.fourthwall.com/hc/en-us/articles/13331279583387-Perks-A-Guide-to-Rewarding-Your-Members", target: "_blank" },
                React.createElement(S.Name, null, "Perks: A Guide to Rewarding Your Members \u2197"),
                React.createElement(S.Image, { src: GuideToRewarding })))));
};
